<template>
  <header
    :class="{ 'bd-banner-navbar': isBannerEnabled, 'bd-navbar-border-repairify': isRepairify, 'bd-navbar-border-mahle': isMahle, 'bd-navbar-border-default': !isRepairify && !isMahle, 'bd-navbar-border-clever': isClever}"
  >
  <div class="row custom-row">
      <div class="col-sm">
        <div class="custom-logo">
          <img
            :src="logo"
            alt="diagnostics"
            style="height: 48px"
          />
        </div>
      </div>
      <div class="col-sm custom-title">
        <h2>{{ $t(appName) }} </h2>
      </div>
      <div class="col-sm">
        <div class="custom-user">
          <!-- Username / Logout -->
          <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
            <li
              v-if="userProfile.userName"
              class="nav-item"
            >
              <a
                id="userProfile"
                href="#"
                @click="goUserProfile"
                :class="{'nav-link': isClever === false, 'nav-link-clever':isClever, 'custom-link':true}"
                title="userProfile"
              >
                <i class="fas fa-user pr-1"></i>
                {{ userProfile.userName }}
              </a>
            </li>
            <li class="nav-space nav-item">
              <a
                id="logout"
                href="#"
                @click="logout"
                :class="{'nav-link': isClever === false, 'nav-link-clever':isClever, 'custom-link':true}"
                title="logout"
              >
                <i class="fas fa-sign-out-alt"></i>
                {{ $t('logout.label.title') }}
              </a>
            </li>
          </ul>
          <div class="custom-name">
            <span>{{ userProfile.lastName }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import globals from '@/plugins/globals.js'
export default {
  name: 'banner-top',
  data() {
    return {
      nav: []
    }
  },
  computed: {
    ...mapGetters('auth', ['userProfile', 'isAllowed']),
    isUKOnly: {
      get() {
        // UK only clients.
        let _appId = globals.appId()
        if (parseInt(_appId) === 1) {
          return true
        }
        return false
      }
    },
    isRepairify() {
      if (this.isUKOnly && globals.isRepairify()) {
        return true
      }
      return false
    },
    isClever() {
      return globals.isClever()
    },
    isMahle() {
      return globals.isMahle()
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    fullname() {
      let name = ''
      if (this.userProfile !== undefined && this.userProfile !== null) {
        name = `${this.userProfile.firstName} ${this.userProfile.lastName}`.trim()
      }
      return name
    },
    appId() {
      return globals.appId()
    },
    appName() {
      return globals.appName()
    },
    logoPath() {
      return globals.logoPath()
    },
    logo() {
      let _logo = ''
      if (this.appId === 5) {
        _logo = '/static/protech.svg'
      } else {
        _logo = this.logoPath
      }
      console.log('Logo path:', _logo)
      return _logo
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    logout() {
      this.clearToken()
      window.location.assign('/')
    },
    goUserProfile() {
      if (!this.isMahle()) {
        window.location.assign('/user/')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-row {
  width: 100%;
}
.custom-title {
  text-align: center;
  width: 100%;
  margin: 0 auto;
}
.custom-link {
  cursor: pointer;
}
.nav-link-clever {
  padding-right: .5rem;
  padding-left: .5rem;
  color: #000000;

  &.active,
  &:hover {
    color: #EAAA00;
    background-color: transparent;
  }
}
.custom-user {
  float: right;
}
.custom-name {
  text-align: center;
  font-size: 0.8em;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
.custom-logo {
  text-align: center;
  padding-bottom: 20px;
}
.nav-space {
    padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/banner-top.vue